const BASE_URL: string = process.env.REACT_APP_PUBLIC_URL || ".";
const SHOW_PAGE: boolean = process.env.REACT_APP_SHOW_PAGE === "true" || false;
const HOMEPAGE: string = process.env.REACT_APP_HOMEPAGE || "../index.html";
const ILO: string = process.env.REACT_APP_ILO || "../ilo/index.html";

const Config = {
  BASE_URL,
  SHOW_PAGE,
  HOMEPAGE,
  ILO,
};

export default Config;
